import React from 'react';
import EventDetail from '../EventDetail';
import { RouteProp, useRoute } from '@react-navigation/native';
import { FacialParamList } from '../../../typings/Params';
import { RootNavigation } from '../../../Routes';

interface EventDetailParams {
    navigation: RootNavigation;
}

export default function SearchEventDetail({ navigation }: EventDetailParams) {
    const route = useRoute<RouteProp<FacialParamList, 'SearchEventDetail'>>();
    return <EventDetail navigation={navigation} route={route} module={'facial'} page={'search'} />;
}
